import { Injectable, signal } from '@angular/core';

/** State behind the in-app "leave this page?" dialog; rendered once by the root layout. */
@Injectable({ providedIn: 'root' })
export class UnsavedChangesPromptService {
  readonly open = signal(false);
  private resolve: ((leave: boolean) => void) | null = null;

  /** Resolves true when the user chooses to leave, false when they stay. */
  ask(): Promise<boolean> {
    // A second navigation while the dialog is open supersedes the first.
    this.answer(false);
    this.open.set(true);
    return new Promise<boolean>((resolve) => (this.resolve = resolve));
  }

  answer(leave: boolean): void {
    this.open.set(false);
    this.resolve?.(leave);
    this.resolve = null;
  }
}
